import { Logger } from '@thesavingsgroup/logger/Logger';
import { createContentfulClient } from './createContentfulClient';
import { getRedirectConfiguration } from './getRedirectConfiguration';
import { getConfigurationFromContentful } from './getConfigurationFromContentful';
import { toRemoteConfiguration } from './toRemoteConfiguration';
import type { ESEMode } from './types/ESEMode';
import type { Reporter } from '@thesavingsgroup/reporting/types/Reporter';
import type { RemoteConfiguration } from './types/RemoteConfiguration';
import type { AxiosAdapter } from 'axios';

type GetConfigurationForDependencies = {
  adapter?: AxiosAdapter;
  baseURL?: string;
  fetcher?: typeof fetch;
  logger?: Logger;
  reporter: Reporter;
  mode?: ESEMode;
};

type GetConfigurationForWithDependencies = (
  configurationCode: string,
  uniqueIdentifier?: string,
) => Promise<RemoteConfiguration | null>;

export const getConfigurationFor =
  ({
    adapter,
    baseURL = import.meta.env.VITE_EXPERIENCES_BASE_URL,
    fetcher = fetch,
    logger = new Logger(),
    mode = import.meta.env.MODE as ESEMode,
    reporter,
  }: GetConfigurationForDependencies): GetConfigurationForWithDependencies =>
  (
    configurationCode: string,
    uniqueIdentifier?: string,
  ): Promise<RemoteConfiguration | null> =>
    Promise.all([
      getConfigurationFromContentful({
        client: createContentfulClient({ adapter, logger, reporter }),
        logger,
        reporter,
      })(configurationCode),
      getRedirectConfiguration({ baseURL, fetcher, reporter })(),
    ]).then(([remote, redirect]) =>
      toRemoteConfiguration({ logger, mode })(
        remote,
        redirect,
        uniqueIdentifier,
      ),
    );
